// Welcome to the project's strategic technical debt reserve
// Beware of load bearing cruft
//

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  postUserRspvForm,
  getRsvpDynamicRsvpQuestions,
  getRSVPResponses,
  postRSVPNameMatch,
} from "../redux/rsvpSlice";
import DatePicker from "react-datepicker";
//import { DateRangePicker } from "react-date-range";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
//import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
//import Checkbox from "@mui/material/Checkbox";
//import "react-date-range/dist/styles.css"; // Main style file
//import "react-date-range/dist/theme/default.css"; // Theme CSS file
import "react-datepicker/dist/react-datepicker.css";
import AddGuestForm, {unableToAttend, fixupCeremonyUnableToAttend} from "./AddGuestForm";
import { getRSVPMarriageDetails } from "../redux/marriageSlice";
import { enGB } from "date-fns/esm/locale";
import RSVPTitle from "./RSVPTitle";

import logo from "../assets/SHIV_logo5.png";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const NewRsvpForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [state, setState] = useState("loading");
  const { rsvpCode } = useParams();
  const [userQuestions, setUserQuestions] = useState([]);
  const [formData, setFormData] = useState({});
  const [inviteDetails, setInviteDetails] = useState("");
  const [selectedRadioValues, setSelectedRadioValues] = useState({});
  const [gogData, setGogData] = useState([]);
  const [title, setTitle] = useState([]);
  const [guestLimits, setGuestLimits] = useState({});
  const [matchName, setMatchName] = useState("");
  const [matchedNames, setMatchedNames] = useState([]);
  const [byNameGuestId, setbyNameGuestId] = useState(null);
  const [byNameGuestName, setbyNameGuestName] = useState(null);
  const [accentColor, setAccentColor] = useState("#5ce1e6");
  const [namedGuestInvites, setNamedGuestInvites] = useState({});

  const [selectedCeremoniesForRsvp, setSelectedCeremoniesForRsvp] = useState([]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const stripUnableToAttend = (value)=>  {
    if (!Array.isArray(value)) return [];
    if (value.indexOf(unableToAttend)>=0) {
      return [];
    }
    return value;
  }

  const fixupCeremonyChange=(oldValue, value) => {
    if (!Array.isArray(value)) value=[unableToAttend];
    if (!Array.isArray(oldValue)) oldValue=[];
    const wasUnableToAttend = oldValue.indexOf(unableToAttend)>=0;
    if (wasUnableToAttend && value.length>1) {
      return value.filter(it=>it!==unableToAttend);
    }
    if (!wasUnableToAttend && value.indexOf(unableToAttend)>=0) {
      return [unableToAttend];
    }
    return value;
  }

  const handleCeremonyInputChange = (event) => {
    var { name, value } = event.target;
    setFormData({ ...formData, [name]: fixupCeremonyChange(formData[name], value) });
  }
  

  const handleRadioChange = (event, questionId) => {
    const {
      target: { value },
    } = event;

    setSelectedRadioValues((prevValues) => ({
      ...prevValues,
      [questionId]: value,
    }));
  };

  useEffect(() => {
    async function runMatch() {
      const res = await dispatch(postRSVPNameMatch({name:matchName, rsvpCode: rsvpCode}));
      if (res.meta.requestStatus === "fulfilled" && Array.isArray(res?.payload?.names)) {
        const names = res.payload.names;
//        if (names.length===1) {
// only one match... could just jump to it
//        }
        setMatchedNames(names);
      }
    }

    runMatch();
  }, [matchName])

  useEffect(() => {
    const handleData = async () => {
      const res = await dispatch(getRsvpDynamicRsvpQuestions({rsvpCode:rsvpCode, id:byNameGuestId}));
      console.log(res);
      if (res.meta.requestStatus === "fulfilled") {
        if (res?.payload?.code_type==='n') {
          setState("name");
          return;
        }
        const selectedQuestions = res.payload?.user_questions;
        setInviteDetails(res.payload?.inviteHtml);
        setUserQuestions(selectedQuestions);
        setSelectedCeremoniesForRsvp(res.payload?.ceremonies);

        if (Array.isArray(res?.payload?.guestCounts)) {
          const newGuestLimits={};
          for (var i=0; i<res.payload.ceremonies.length; i++) {
            newGuestLimits[res.payload.ceremonies[i]] = res.payload.guestCounts[i];
          }
          setGuestLimits(newGuestLimits);
          console.log("Limits from main guest", newGuestLimits);
        }
        await getResponses(selectedQuestions); // always after invites, etc
        setState("ready");
      } else {
        setState("error");
      }
    };

    const getMarriageDetails = async () => {
      const response = await dispatch(getRSVPMarriageDetails(rsvpCode));
      if (response.meta.requestStatus === "fulfilled") {
        var txt = response.payload.couple_name;
        if (response.payload?.rsvp_by) {
          const d = new Date(response.payload.rsvp_by);
          if (!isNaN(d)) {
            txt += " by " + formatDate(d);
          }
        }
        if (response.payload?.rsvp_style && response.payload?.rsvp_style?.color) {
          setAccentColor(response.payload?.rsvp_style?.color || "#5ce1e6");
        }
        setTitle(txt);
      }
    };

    const formatDate = (d) => {
      const nd = new Date(d);
      if (isNaN(nd)) return "";
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
 //     const options2 = { hour: 'numeric', minute: 'numeric'}; + " " + nd.toLocaleTimeString("en-GB", options2)
      return nd.toLocaleDateString("en-GB", options);
    }
  
    const getResponses = async (selectedQuestions) => {
      const response = await dispatch(getRSVPResponses({rsvpCode:rsvpCode, id:byNameGuestId}));
      let nameQuestionIndex='';
      if (response.meta.requestStatus === "fulfilled") {
        const newFormData={};
        const radios={};
        // default name, email and mobile to ones in the guest table
        const guest=response?.payload?.guest[0];
        for (const question of selectedQuestions) {
          switch (question.question_number) {
            case 1:
              nameQuestionIndex="question"+question.id;
              newFormData[nameQuestionIndex] = guest?.guest_name || "";
              break;
            case 3:
              newFormData["question"+question.id] = guest?.email || "";
              break;
            case 4:
              newFormData["question"+question.id] = guest?.mobile_number || "";
              break;
          }
        }
        response?.payload?.guests?.forEach((item) => {
          newFormData["question"+item.question_id]=item.response;
          // ott, but works:
          radios[item.question_id]=item.response;
          if (item.extra_details) {
            newFormData["question"+item.question_id+"RadioText"]=item.extra_details;
          }
        });
        setFormData((prevValues) => ({
          ...prevValues, ...newFormData
        }));
        setSelectedRadioValues((prevValues) => ({
          ...prevValues, ...radios
        }));

        const gogKeys=[];
        const gogs=[];
        response?.payload?.gogs?.forEach((item) => {
          var idx=gogKeys.indexOf(item.gog_id);
          if (idx<0) {
            idx = gogKeys.length;
            gogKeys.push(item.gog_id);
            gogs[idx]={formData:{}};
          }
          if (item.extra_details) {
            gogs[idx].formData["question"+item.question_id+"RadioText"]=item.extra_details;
          }
          gogs[idx].formData["question"+item.question_id] = item.response;
          gogs[idx].id = item.gog_id;
          gogs[idx].isNamed = false;
        });

        const extraGuests = {};
        response?.payload?.namedGogs?.forEach((item) => {
          var idx=gogKeys.indexOf(item.id);
          if (idx<0) { // inject named guests with no prior data
            idx = gogKeys.length;
            gogKeys.push(item.id);
            gogs[idx]={formData:{}, id:item.id};
            if (nameQuestionIndex) {
              gogs[idx].formData[nameQuestionIndex] = item.gog_name;
            }
          }
          gogs[idx].isNamed = true;
          // matchup named guests with their custom question sets
          if (item.group_id && response?.payload?.questionCache[item.group_id]) {
            gogs[idx].questions = response?.payload?.questionCache[item.group_id].user_questions;
          }
          // matchup named guests with their custom invitation sets
          if (Array.isArray(item.invites) && item.invites.length>0) {
            gogs[idx].ceremonies=[];
            for (const ceremony_id of item.invites) {
              const match = response?.payload?.ceremonies.find(c=>c.id==ceremony_id);
              if (match) {
                gogs[idx].ceremonies.push(match.ceremony_name);
                extraGuests[match.ceremony_name] = (extraGuests[match.ceremony_name] || 0) + 1;
              }
            }
          }
        });
        setNamedGuestInvites(extraGuests);
        console.log("Limits from main invites", guestLimits, "Named guest invites", extraGuests);
        setGogData(gogs);
      }
    };

    getMarriageDetails();
    handleData();
  }, [dispatch, byNameGuestId]);

  const dateFor = function(qid) {
    const v=formData[`question${qid}`];
    if (!v) return null;
    const d=new Date(v);
    if (isNaN(d)) return null;
    return d;
  }

  const dateDeArray = function(qid, idx) {
    const v=formData[`question${qid}`];
    if (!Array.isArray(v)) return null;
    var d=new Date(v[idx]);
    if (isNaN(d)) return null;
    return d;
  }

  const hasMoreInvites = () => {
    try {
      // count one INVITE for each event for the head guest
      const attendingCounts = {};
      for (const event of selectedCeremoniesForRsvp) {
        attendingCounts[event] = (attendingCounts[event] || 0) + 1;
      }
      // count INVITES for named guests
      for (const event in namedGuestInvites) {
        attendingCounts[event] = (attendingCounts[event] || 0) + namedGuestInvites[event];
      }

      // count attendance of NON-NAMED gogs
      gogData?.filter(g=>!g.isNamed).forEach((gog) => {
        (gog.questions || userQuestions)?.filter(q=>q.question_type === "Api").forEach((question) => {
          const questionValue = gog?.formData[`question${question.id}`];
          if (Array.isArray(questionValue)) {
            stripUnableToAttend(questionValue).forEach(event=>{
              attendingCounts[event] = (attendingCounts[event] || 0) + 1;
            });
          }
        });
      });

      console.log(guestLimits, "vs", attendingCounts);
      for (const event in guestLimits) {
        if (guestLimits[event]>0) {
          if (Number.isInteger(attendingCounts[event])) {
            if (attendingCounts[event]<guestLimits[event]) {
              console.log("Floating invites for", event);
              return true;
            }
          } else {
            console.log("Floating invites for", event);
            return true;
          }
        }
      }
      console.log("No floating invites");
      return false;
    } catch (e) {
      console.log("failed to count invites: ", e);
      return true;
    }
  }

  const handleSubmit = async () => {
    // Initialize arrays to collect question IDs with values and their corresponding values
    // abandon all hope, ye who enter here
    const questionIdsWithValues = [];
    const questionValues = [];
    const extraDetails = {};
    var attendingEvents = [];
    const gogSaveData = [];
    var firstName = "";
    var lastName = "";
    var phone = "";
    var email = "";

    if (state==="submitting") return;
    setState("submitting");

    for (const question of userQuestions) {
      const questionId = question.id;
      const questionValue = formData[`question${questionId}`];

      if (question.question_type === "MultiDropTypeIn") {
        extraDetails[questionId] = formData[`question${questionId}RadioText`];
        if (extraDetails[questionId] || questionValue) { // save for lone typein as well as selected values
          questionIdsWithValues.push(questionId);
          questionValues.push(questionValue || []);
        }
      } else if (questionValue) {
        questionIdsWithValues.push(questionId);
        questionValues.push(questionValue);
      }

      if (
        question.question_type === "Radio text" &&
        selectedRadioValues[questionId] === "yes"
      ) {
        questionIdsWithValues.push(questionId); // Add the question ID to the array
        questionValues.push("yes"); // Add "yes" for questions answered with "Yes"
        const radioTextValue = formData[`question${questionId}RadioText`];

        if (radioTextValue) {
          extraDetails[questionId] = radioTextValue;
        }
      } else if (
        question.question_type === "Radio text" &&
        selectedRadioValues[questionId] === "no"
      ) {
        questionIdsWithValues.push(questionId); // Add the question ID to the array
        questionValues.push("no"); // Add "no" for questions answered with "No"
      }
      if (question.question_type === "Api") {
        if (!Array.isArray(questionValue)) {
          toast.error("Which events will you be attending?", {autoClose:10000});
          setState("ready");
          return;
        }
        attendingEvents = stripUnableToAttend(questionValue);
      }

      switch (question.question_number) {
        case 1:
          firstName = questionValue;
          break;
        case 2:
          lastName = questionValue;
          break;
        case 3:
          email = questionValue;
          break;
        case 4:
          phone = questionValue;
          break;
      }
    }

    gogData?.forEach((gog) => {
      const newData={id:gog.id, answers:[], firstName:"", lastName:"", attending:[], invites: gog.ceremonies, isNamed:gog.isNamed};
      (gog.questions || userQuestions)?.forEach((question) => {
        const questionId = question.id;
        const questionValue = gog?.formData[`question${questionId}`];
        if (questionValue === undefined) {
          return;
        }
        if (question.question_type === "Api") {
          newData.attending = stripUnableToAttend(questionValue);
        }
        newData.answers.push({
          id: questionId,
          val: questionValue,
          extra: gog.formData[`question${questionId}RadioText`] || "",
        });
        switch (question.question_number) {
          case 1:
            newData.firstName = questionValue;
            break;
          case 2:
            newData.lastName = questionValue;
            break;
          case 3:
            newData.email = questionValue;
            break;
          case 4:
            newData.phone = questionValue;
            break;
        }
      });
      gogSaveData.push(newData);
    });

    // can only submit if head guest INVITES + non named gog attending >=attending count

    const floatingGogCount={};
    for (const gog of gogSaveData) {
      if (!gog.isNamed) {
        for (const event of gog.attending) {
          floatingGogCount[event] = (floatingGogCount[event] || 0) + 1;
        }
      }
    }

    var allOK=true;
    for (const event in guestLimits) {
      const headLimit = guestLimits[event] || 0;
      const namedCount = namedGuestInvites[event] || 0;
      const headCount = attendingEvents.indexOf(event)>=0 ? 1 : 0;
      const floatingCount = floatingGogCount[event] || 0;
      console.log("*", event, "Limit", headLimit, "named", namedCount, "head", headCount, "float", floatingCount);
      let guestCount = headLimit;
      // Take off named count, don't reject due to number of named invites
      guestCount = Math.max(0, guestCount - namedCount);
      if (headCount>0) { // head guest is attending
        guestCount -= headCount;
        if (guestCount<0) {
          toast.error(`Sorry, there is no invite to ${event} for your head guest`, {autoClose:15000});
          allOK = false;
          continue;
        }
        guestCount -= floatingCount;
      } else { // head guest not attending
        if (floatingCount>0) { // but there are floating guests
          guestCount--; // reserve the head guests invite
          guestCount -= floatingCount;
        }
      }
      if (guestCount<0) {
        toast.error(`Too many guests for ${event}`, {autoClose:15000});
        allOK = false;
      }
    }

    if (!allOK) {
      setState("ready");
      return;
    }

    const data = {
      rsvpCode: rsvpCode,
      byNameGuestId: byNameGuestId,
      question_id: questionIdsWithValues,
      extra_details: extraDetails,
      response: questionValues,
      attending: attendingEvents,
      gogs: gogSaveData,
      first_name: firstName,
      last_name: lastName,
      mobile_number: phone,
      email: email,
    };

    console.log("Submitting ", data);
    const result = await dispatch(postUserRspvForm(data));
    if (result?.payload?.newRsvpCode?.length>0) {
      toast.dismiss();
      navigate("/rsvp/done/code/" +result.payload.newRsvpCode );
    } else {
      setState("ready");
    }
  };

  const handleDeleteGuest = (index) => {
    setGogData(oldArray=>oldArray.filter((v,i)=>i!=index));
  };

  const handleGogChange = (index, name, value) => {
    setGogData((oldData) => {
      const newData = [...oldData];
      newData[index].formData[name] = value;
      return newData;
    });
  }

  const handleGogCeremonyChange = (index, name, value) => {
    setGogData((oldData) => {
      const newData = [...oldData];
      newData[index].formData[name] = fixupCeremonyChange(newData[index].formData[name], value);
      return newData;
    });
  }

  const isQuestionNumber=(num, val) => {
    for (const question of userQuestions) {
      if (question.question_number===num) {
        return String(formData[`question${question.id}`]).toLowerCase()===val;
      }
    }
    return false;
  }

  const showQuestion = (question) => { // NOTE: DUPLICATED: IN AddGuestForm AND NewRsvpForm
    if (question.question_number===13 || question.question_number===14) {
      return isQuestionNumber(12, "yes"); // mehndi
    }
    if (question.question_number===23 || question.question_number===24) {
      return isQuestionNumber(22, "yes"); // venue
    }
    if (question.question_number===26) {
      return isQuestionNumber(22, "no"); // venue
    }
    if (question.question_number===28) {
      return isQuestionNumber(27, "yes"); // extend stay
    }
    return true
  }

  const asArray = (a) => {
    if (Array.isArray(a)) return a;
    if (a===undefined || a===null) return [];
    return [a];
  }

  if (state==="loading") {
    return <div>
      <div className="container card-b-1">
        <RSVPTitle>Loading...</RSVPTitle>
      </div>
    </div>
  }

  if (state==="error") {
    return <div>
      <div className="container card-b-1">
        <RSVPTitle>RSVP not found</RSVPTitle>
      </div>
    </div>
  }

  if (state==="name") {
    return <div>
      <div className="container card-b-1">
        <RSVPTitle>Please {matchedNames.length>0 ? "select" : "enter"} your name</RSVPTitle>
        <div className="card-home" style={{textAlign:"center",backgroundColor:"#fff"}}>
          <TextField
            id="nameMatch"
            label="Enter your name"
            variant="outlined"
            onChange={(e)=>setMatchName(e.target.value)}
          />
          {matchedNames.length>0 && <>
            <div className="row my-3">
              {matchedNames.map((rec)=>
                <Button className="my-2"
                  onClick={()=>{
                    setbyNameGuestId(rec.id);
                    setbyNameGuestName(rec.guest_name);
                  }}
                >{rec.guest_name}{rec.aka && ` (${rec.aka})`}</Button>
              )}
            </div>
          </>}
        </div>
      </div>
    </div>
  }

  return (
    <div>
      <div className="container card-b-1">
        <RSVPTitle>Please RSVP for your invitation from {title}</RSVPTitle>

        <div className="card-home" style={{backgroundColor:accentColor}}>
          <div dangerouslySetInnerHTML={{__html: inviteDetails}} 
              style={{textAlign:"center"}} className="mb-3" >
          </div>
          <form className="row card-rsvp new-rsvp">
            {userQuestions
               ?.map((question, index) => (
              showQuestion(question) && <div
                className="col-sm-12 col-md-4 col-lg-4 rsvp-padding rsvp-form"
                key={index}
              >
                <div className="question">
                  <label htmlFor={`question${question.id}`}>
                    {question.questions}
                  </label>

                  <div className="form-rs">
                    <div className="crose"></div>
                    {question.question_type === "Free text" && (
                      <div className="questionText">
                        <input
                          type="text"
                          className="form-control"
                          value={formData[`question${question.id}`] || ""}
                          id={`question${question.id}`}
                          name={`question${question.id}`}
                          onChange={handleInputChange}
                        />
                      </div>
                    )}
                    {question.question_type === "Api" && (<>
                      (Please select the event(s) you can attend)
                      <div className="col-sm-12 col-md-4 col-lg-3 rsvp-padding">
                        <FormControl sx={{ m: 1, width: 300 }}>
                          <InputLabel id={`demo-select-label${index}`}>
                            {question.questions}
                          </InputLabel>

                          <Select
                            labelId={`demo-select-label${index}`}
                            id={`question${question.id}`}
                            name={`question${question.id}`}
                            multiple // Set to true for multi-select
                            value={fixupCeremonyUnableToAttend(formData[`question${question.id}`])}
                            onChange={handleCeremonyInputChange}
                            input={<OutlinedInput label="Tag" />}
                            renderValue={(selected) => selected.join(", ")}
                            MenuProps={MenuProps}
                          >
                            {selectedCeremoniesForRsvp?.map((value) => (
                              <MenuItem
                                key={value}
                                value={value}
                              >
                                {value}
                              </MenuItem>
                            ))}
                            <MenuItem key={unableToAttend} value={unableToAttend}>
                              {unableToAttend}
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </>)}

                    {question.question_type === "MultiDropTypeIn" && 
                    <div className="col-sm-12 col-md-4 col-lg-3 rsvp-padding">
                      <FormControl sx={{ m: 1, width: 300 }}>
                        <InputLabel id={`demo-select-label${index}`}>
                          {question.questions}
                        </InputLabel>
                        <Select
                          labelId={`demo-select-label${index}`}
                          id={`question${question.id}`}
                          name={`question${question.id}`}
                          multiple
                          value={asArray(formData[`question${question.id}`])}
                          onChange={handleInputChange}
                          input={<OutlinedInput label="Tag" />}
//                          renderValue={(selected) => (selected.join) ? selected.join(", ") : selected}
                          MenuProps={MenuProps}
                        >
                          {question?.question_value?.map((value) => (
                            <MenuItem key={value} value={value}>
                              {value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          id={`question${question.id}`}
                          name={`question${question.id}RadioText`}
                          placeholder={question.question_number===8 ? "Please specify any allergies not on our list" : ""}
                          value={formData[`question${question.id}RadioText`] || ""}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </div>
                    </div>}


                    {question.question_type === "Dropdown" && (
                      <div className="col-sm-12 col-md-4 col-lg-3 rsvp-padding">
                        <FormControl sx={{ m: 1, width: 300 }}>
                          <InputLabel id={`demo-select-label${index}`}>
                            {question.questions}
                          </InputLabel>
                          {(question.question_number === 7 && (
                            <Select
                              labelId={`demo-select-label${index}`}
                              id={`question${question.id}`}
                              name={`question${question.id}`}
                              multiple // Set to true for multi-select
                              value={asArray(formData[`question${question.id}`])}
                              onChange={handleInputChange}
                              input={<OutlinedInput label="Tag" />}
                              renderValue={(selected) => (selected.join) ? selected.join(", ") : selected}
                              MenuProps={MenuProps}
                            >
                              {question?.question_value?.map((value) => (
                                <MenuItem key={value} value={value}>
                                  {value}
                                </MenuItem>
                              ))}
                            </Select>
                          )) || (
                            <Select
                              labelId={`demo-simple-select-label${index}`}
                              id={`question${question.id}`}
                              name={`question${question.id}`}
                              value={formData[`question${question.id}`] || ""}
                              onChange={handleInputChange}
                              input={<OutlinedInput label="Tag" />}
                              MenuProps={MenuProps}
                            >
                              {question?.question_value?.map((value) => (
                                <MenuItem key={value} value={value}>
                                  {value}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        </FormControl>
                      </div>
                    )}

                    {question.question_type === "Number" && (
                        <div>
                          <input
                            type="number"
                            className="form-control"
                            id={`question${question.id}`}
                            name={`question${question.id}`}
                            value={formData[`question${question.id}`] || 0}
                            onChange={handleInputChange}
                          />
                        </div>
                      )}

                    {question.question_type === "Radio text" && (
                      <div className="question1">
                        <input
                          type="radio"
                          id={`question${question.id}`}
                          name={`question${question.id}`}
                          value="yes"
                          onChange={(event) =>
                            handleRadioChange(event, question.id)
                          }
                          checked={selectedRadioValues[question.id] === "yes"}
                        />
                        <label htmlFor={`question${question.id}`}>Yes</label>
                        <input
                          type="radio"
                          id={`question${question.id}`}
                          name={`question${question.id}`}
                          value="no"
                          onChange={(event) =>
                            handleRadioChange(event, question.id)
                          }
                          checked={selectedRadioValues[question.id] === "no"}
                        />
                        <label htmlFor={`question${question.id}`}>No</label>
                      </div>
                    )}

                    {question.question_type === "Radio text" &&
                      selectedRadioValues[question.id] === "yes" && ( // Conditionally render the text box
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            id={`question${question.id}`}
                            name={`question${question.id}RadioText`} // Append "RadioText" to the name
                            value={formData[`question${question.id}RadioText`] || ""}
                            onChange={(e) => handleInputChange(e)}
                          />
                        </div>
                      )}

                    {question.question_type === "Calendar" && (
                      <div className="question1">
                        <DatePicker
                          className="form-control"
                          id={`question${question.id}`}
                          name={`question${question.id}`}
                          selected={dateFor(question.id)}
                          locale={enGB}
                          showTimeSelect
                          timeIntervals={10}
                          timeFormat="p"
                          dateFormat="Pp"
                          onChange={(date) => {
                            handleInputChange({
                              target: {
                                name: `question${question.id}`,
                                value: date,
                              },
                            });
                          }}
                        />
                      </div>
                    )}

                    {question.question_type === "Date Range" && (
                      <div className="question1">
                        <DatePicker
                          className="form-control"
                          id={`question${question.id}`}
                          name={`question${question.id}`}
                          startDate={dateDeArray(question.id, 0)}
                          endDate={dateDeArray(question.id, 1)}
                          locale={enGB}
                          dateFormat="P"
                          selectsRange
                          onChange={(dates) => {
                            handleInputChange({
                              target: {
                                name: `question${question.id}`,
                                value: [
                                  (dates[0]) ? dates[0].toISOString() : undefined, 
                                  (dates[1]) ? dates[1].toISOString() : undefined
                                ],
                              },
                            });
                          }}
                        />
                      </div>
                    )}


                  </div>
                </div>
              </div>
            ))}
          </form>

          <div className="crl"></div>
          <div>
            <div>
              { gogData.map((gog, index)=>
                <AddGuestForm 
                  selectedCeremoniesForRsvp={gog.ceremonies || selectedCeremoniesForRsvp} 
                  gogAnswers={gog}
                  userQuestions={gog.questions || userQuestions} 
                  mainFormData={formData}
                  onDelete={()=>handleDeleteGuest(index)}
                  onChange={(name, value)=>handleGogChange(index, name, value)}
                  onCeremonyChange={(name, value)=>handleGogCeremonyChange(index, name, value)}
                />
              )}
            </div>
          </div>
          
          <div class="container-fluid">
            <div class="row justify-content-between">
              <div class="col-lg-auto text-center">
                {hasMoreInvites() && <><button
                  type="button"
                  className="view-r-btn m-0" 
                  style={{float:"none"}}
                  onClick={() => {
                    setGogData(oldArray => [...oldArray, {formData:{}}]);
                  }}
                  >
                    Add a guest
                  </button>
                </>}
              </div>

              <div class="col-lg-auto text-center px-0 py-2">
                {hasMoreInvites() && <>Please <strong>ONLY RSVP</strong> for named guests or no. of guests on your invitation</>}
              </div>

              <div class="col-lg-auto text-center">
                <button className="view-r-btn m-0"
                    style={{float:"none"}}
                    onClick={handleSubmit}  
                    disabled={state!=="ready"}
                  >
                  Submit {(state!=="ready") && 
                  <LinearProgress color="inherit" sx={{
                    position: 'absolute',
                    top: '80%',
                    left: '0%',
                    width: "100%",
                  }} />}
                </button>
              </div>

            </div>
          </div>
        </div>
        <div className="my-3 row flex-nowrap justify-content-center">
          <a href="https://www.shiv-worldwide.com/" 
            style={{width:"160px",display:"block",boxSizing:"content-box", color:"#000",textDecoration:"none",textAlign:"center"}}
          >
            <div className="m-1">
              Brought to you by
            </div>
            <img src={logo} alt="SHIV: Share Heartfelt Invitations Virtually" style={{width:"100%"}} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default NewRsvpForm;
